import React from 'react';


export default function Contact({ContactRef}) {
  return (
    <div ref={ContactRef} className='relative flex flex-col min-h-screen justify-center z-10 bg-gradient-to-t from-[#545a5d] to-[#202947]'>
        <h1 className='text-3xl md:text-5xl font-bold self-center text-[#80ed99] text-center'>
          Contact Me!
          </h1>
          <h1 className='font-sans text-[15px] md:text-[20px] self-center mt-[-20px] text-[#a7abdf]'>
         Work with me.
          </h1>
      <div className='bg-image flex flex-wrap justify-center gap-6 p-14'>
        <form className='flex flex-col gap-3'>
         <input type='text' placeholder='Enter your name' className='text-white bg-[#545a5d] rounded-3xl  p-2'/>
         <input type='email' placeholder='Enter your email' className='text-white bg-[#545a5d] rounded-3xl p-2'/>
         <textarea placeholder='Enter your message' className='text-white bg-[#545a5d] rounded-3xl p-2'/> 
         <button className='text-white bg-[#545a5d] rounded-3xl w-[50%] self-center border-[1px] border-white hover:shadow-black hover:shadow-[0_0_8px_5px_rgba(255,255,255,0.6)]  shadow-black  shadow-[inset_0_0_8px_5px_rgba(255,255,255,0.6)] p-2'>Submit</button>
        </form>

     
      </div>

    </div>
  );
}
